var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.587 0.677134C17.7121 0.286811 17.587 0 16.9914 0H15.0222C14.5215 0 14.2907 0.247763 14.1655 0.520973C14.1655 0.520973 13.1641 2.80433 11.7455 4.28753C11.2865 4.71686 11.0779 4.85347 10.8275 4.85347C10.7024 4.85347 10.5212 4.71686 10.5212 4.32657V0.677136C10.5212 0.208748 10.3759 0 9.95857 0H6.8641C6.5512 0 6.36302 0.21739 6.36302 0.423417C6.36302 0.867438 7.0723 0.969835 7.14541 2.21887V4.93157C7.14541 5.52632 7.03059 5.63414 6.78024 5.63414C6.11267 5.63414 4.4888 3.34058 3.5257 0.71615C3.33695 0.206053 3.14764 0 2.64437 0H0.675163C0.112532 0 0 0.247763 0 0.520973C0 1.00888 0.667605 3.42885 3.10848 6.62943C4.73572 8.81517 7.02839 10 9.11462 10C10.3663 10 10.5212 9.73684 10.5212 9.28355V7.63158C10.5212 7.10526 10.6398 7.00023 11.0362 7.00023C11.3282 7.00023 11.8289 7.13683 12.9972 8.19068C14.3324 9.43968 14.5525 10 15.3036 10H17.2728C17.8354 10 18.1167 9.73684 17.9544 9.21751C17.7768 8.69992 17.1394 7.94897 16.2935 7.05876C15.8345 6.55136 15.1461 6.00494 14.9374 5.73167C14.6453 5.38043 14.7288 5.22427 14.9374 4.91204C14.9374 4.91204 17.3366 1.75048 17.587 0.677134Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.d2fb201b2374ed1a2c315d73ebb9e6e4.svg";
export { ForwardRef as ReactComponent };